import { createUseStyles } from 'react-jss';
import colors from "../../../../utils/colors";

var styles = {
  attributeWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '1.2rem'
  },
  planTileName: {
    width: '40%',
    letterSpacing: '0.02rem',
    font: {
      size: '1.4rem',
      lineHeight: '2.0rem',
      weight: 500
    },
    padding: '0 1rem 0 0',
    boxSizing: 'border-box'
  },
  planTileValue: {
    flex: '1 1 55%',
    letterSpacing: '0.02rem',
    font: {
      size: '1.4rem',
      lineHeight: '2.0rem',
      weight: 400
    },
    color: colors.neutral[700]
  },
  planTiles: {
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    flex: '2 1 65%'
    // Padding is not set explicitly because styles with conditions have lower priority
    // and their styles are overridden. Therefore, the padding is thrown from the outside
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map